import styled from 'styled-components'

export const CopyButtonContainer = (styled.button`
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: rgba(0, 0, 0, 0.05);
    border-radius: 100%;
    cursor: pointer;
    appearance: none;
    aspect-ratio: 1/1;
    max-width: 48px;
    max-height: 48px;
    padding: 8px;
    border-width: 1px;
    border-style: solid;
`) as any; // eslint-disable-line @typescript-eslint/no-explicit-any
